<mat-chip-list>
  <mat-chip disabled *ngIf="statusDetails?.text" [class]="'label ' + statusDetails?.class">
    <span>{{ statusDetails.text | translate }}</span>
    <mat-icon *ngIf="statusDetails?.icon">{{ statusDetails.icon }}</mat-icon>
  </mat-chip>
  <mat-chip *ngIf="!statusDetails?.text" class="label label-default">
    <span>No status</span>
  </mat-chip>
</mat-chip-list>
